import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import styles from "./CreateFeedPage.module.css";
import PageHeader from "NewsAdmin/Shared/PageHeader";
import FeedBanner from "NewsAdmin/Shared/FeedBanner";
import ChooseFeedTypeList from "NewsAdmin/Shared/ChooseFeedTypeList";

import CustomizeStandardPage from "../CustomizeStandardPage";
import CustomizeStandingPage from "../CustomizeStandingPage";
import CustomizeBanner from "../CustomizeBanner";
import {
  useFeedItemOptionsDropdown,
  useFeedItemOptionsDropdownGroup,
} from "NewsAdmin/Shared/FeedItemOptionsDropdown/useFeedItemOptionsDropdown";

export function CreateFeedPage({}) {
  const history = useHistory();
  const { data: diamondsList, isLoading: isLoadingDiamonds } =
    useFeedItemOptionsDropdown();
  const { data: groupsList, isLoading: isLoadingGroups } =
    useFeedItemOptionsDropdownGroup();

  const [page, setPage] = useState("create");

  const onStandardContent = () => {
    setPage("standard");
  };
  const onStandingOrder = () => {
    setPage("standing");
  };
  const onBanner = () => {
    setPage("banner");
  };

  const onCancel = () => {
    history.push(`/marketing/news/feed`);
  };

  return (
    <>
      {page === "create" && (
        <>
          <PageHeader onClick={onCancel} isHome={false} />
          <FeedBanner status={"Create"} onCancel={onCancel} />
          <div className={styles.container}>
            <ChooseFeedTypeList
              onStandardContent={onStandardContent}
              onStandingOrder={onStandingOrder}
              onBanner={onBanner}
            />
          </div>
          <div className={styles.emptyFooterBar} />
        </>
      )}
      {page === "standard" && (
        <CustomizeStandardPage
          isNew={true}
          setPage={setPage}
          diamondsList={diamondsList}
          groupsList={groupsList}
        />
      )}
      {page === "standing" && (
        <CustomizeStandingPage
          isNew={true}
          setPage={setPage}
          diamondsList={diamondsList}
          groupsList={groupsList}
        />
      )}
      {page === "banner" && (
        <CustomizeBanner
          isNew={true}
          setPage={setPage}
          diamondsList={diamondsList}
          groupsList={groupsList}
        />
      )}
    </>
  );
}
